<h1 style="text-align: center">{{ 'turbo.core.SmsCodeDialog.txtHeadline' | translate : 'Digital signature is required' }}</h1>
<div class="container" style="width: 480px; margin-top: 20px">
  <div class="row">
    <div class="col-sm-6">
      <img style="margin-top: 25px; margin-left: -10px" src="/images/Icons/DigitalSign.png" width="210" height="210" />
    </div>
    <div class="col-sm-6" style="background-color: white; border: 1px solid #ccc; padding: 15px">
      <div>
        <mat-form-field style="width: 200px; min-width: 200px;">
          <input #txtPin type="password" autocomplete="new-password" [(ngModel)]="pin" matInput placeholder="{{ 'turbo.core.SmsCodeDialog.tipPin' | translate : 'Enter signing code...' }}" [required] (keyup.enter)="close(txtPin.value)" />
        </mat-form-field>
        <div style="text-align: center">
          <t4-numericKeyboard (number)="numberClicked($event)"></t4-numericKeyboard>
        </div>
      </div>
      <div *ngIf="retry">{{ 'turbo.core.SmsCodeDialog.txtRetry' | translate : 'Invalid signing code' }}</div>
      <div style="text-align: center;">
        <button mat-button style="margin: 2px;" color="primary" [mat-dialog-close]="txtPin.value" [disabled]="!txtPin.value">{{ 'turbo.core.SmsCodeDialog.cmdSend' | translate : 'Confirm' }}</button>
        <button mat-button style="margin: 2px;" mat-dialog-close>{{ 'turbo.core.messagebox.cmdCancel' | translate : 'Cancel' }}</button>
      </div>
    </div>
    <div class="col-sm-6">
    </div>
    <div class="col-sm-6 text-center">
      <button class="btn btn-default" style="margin: 2px;" (click)="bypassDigitalSignature()">{{ 'turbo.core.SmsCodeDialog.cmdBypass' | translate : 'Continue without digital signature' }}</button>
    </div>
  </div>
    </div>
